import { Box, Center, VStack } from '@chakra-ui/react';
import React from 'react';
import GoogleButton from 'react-google-button';
import { config } from 'util/constants';

export default function FailedLoginPage() {
    return (
        <VStack>
            <Box textAlign={'center'} fontSize={'25px'} fontWeight={'medium'} margin={'0 auto'} width={{ base: '85%', md: '66%', lg: '50%' }}>
                Please sign in with a RoboTigers account
            </Box>
                <Center>
                    <a style={{ marginTop: '100px' }} href={`${config.API_URL}/auth/google`}>
                        <GoogleButton/>
                    </a>
                </Center>
        </VStack>
    );
}